import FilterSection from './components/FilterSection/FilterSection';
import GridSection from './components/GridSection/GridSection';

import classes from './constrainedForecastBulkEdit.module.scss';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';
import { useConstrainedForecastBulkEdit } from './constrainedForecastBulkEdit.logic';
import ConfirmationModal from 'components/ConfirmationModal/ConfirmationModal';

const ConstrainedForecastBulkEdit = () => {
  const {
    editData,
    setEditData,
    setEditDataCopy,
    filterpayload,
    isDataLoading,
    setIsDataLoading,
    ndcNotesSet,
    ndcError,
    setNdcNotesSet,
    getForecastValue,
    setForecastValue,
    isBtnEnabled,
    isSalveAllBtnEnabled,
    handleSingleSave,
    handleSaveAllEdited,
    ndcSaveLoading,
    isSaveAllLoading,
    isNotesLoading,
    notesData,
    isNoteSaving,
    getNotesData,
    handleAddNote,
    hasMore,
    nextPageLoading,
    loadMore,
    showCancelAlert,
    setShowCancelAlert,
    showFilterAlert,
    setShowFilterAlert,
    isRowsEdited,
    singleSaveModalVisibility,
    setSingleSaveModalVisibility,
    saveAllModalVisibility,
    setSaveAllModalVisibility,
    setNotesData,
    isNoteEdited,
    setIsNoteEdited,
    isNoteDeleted,
    setIsNoteDeleted,
    handleCopy,
    handleEditNote,
    handleDeleteNote,
    deletingNote,
    isNoteDeleting,
    isDeleteClicked,
    setIsDeleteClicked,
    setDeletingNote,
    initialloading,
    handleApplyFilter,
    handleCancelButtonClick,
    // New accordion props
    expandedRows,
    toggleRowExpansion,
    isRowExpanded,
    getBaselineValue,
    // New type selection props
    forecastTypeSelection: _forecastTypeSelection,
    getSelectedForecastType,
    handleForecastTypeChange,
    shouldShowToggle,
    getAvailableForecastTypes: _getAvailableForecastTypes,
    getDefaultForecastType: _getDefaultForecastType,
    isForecastTypeChangeable: _isForecastTypeChangeable,
    initializeForecastTypeForRow: _initializeForecastTypeForRow,
    // New concept sorting prop
    handleConceptSort,
    getRowStatus,
  } = useConstrainedForecastBulkEdit();

  const navigate = useNavigate();

  return (
    <div className={classes.container}>
      {/* Filter component */}
      <FilterSection
        filterpayload={filterpayload}
        isDataLoading={isDataLoading}
        areChangesToBeSaved={isRowsEdited()}
        handleApplyFilters={handleApplyFilter}
        showAlert={showFilterAlert}
        setShowAlert={setShowFilterAlert}
      />
      {/* grid component */}
      <GridSection
        loading={isDataLoading}
        setIsDataLoading={setIsDataLoading}
        data={editData}
        setData={setEditData}
        initialloading={initialloading}
        handleCopy={handleCopy}
        setCopyData={setEditDataCopy}
        getForecastValue={getForecastValue}
        setForecastValue={setForecastValue}
        isBtnEnabled={isBtnEnabled}
        isSalveAllBtnEnabled={isSalveAllBtnEnabled}
        notesSet={ndcNotesSet}
        setNoteSet={setNdcNotesSet}
        ndcError={ndcError}
        handleSingleSave={handleSingleSave}
        handleSaveAllEdited={handleSaveAllEdited}
        ndcSaveLoading={ndcSaveLoading}
        isSaveAllLoading={isSaveAllLoading}
        isNotesLoading={isNotesLoading}
        notesData={notesData}
        setNotesData={setNotesData}
        isNoteEdited={isNoteEdited}
        setIsNoteEdited={setIsNoteEdited}
        isNoteDeleted={isNoteDeleted}
        setIsNoteDeleted={setIsNoteDeleted}
        isNoteSaving={isNoteSaving}
        getNotesData={getNotesData}
        handleAddNote={handleAddNote}
        handleEditNote={handleEditNote}
        handleDeleteNote={handleDeleteNote}
        deletingNote={deletingNote}
        isNoteDeleting={isNoteDeleting}
        isDeleteClicked={isDeleteClicked}
        setIsDeleteClicked={setIsDeleteClicked}
        setDeletingNote={setDeletingNote}
        hasMore={hasMore}
        loadMore={loadMore}
        nextPageLoading={nextPageLoading}
        singleSaveModalVisibility={singleSaveModalVisibility}
        setSingleSaveModalVisibility={setSingleSaveModalVisibility}
        saveAllModalVisibility={saveAllModalVisibility}
        setSaveAllModalVisibility={setSaveAllModalVisibility}
        // New accordion props
        expandedRows={expandedRows}
        toggleRowExpansion={toggleRowExpansion}
        isRowExpanded={isRowExpanded}
        getBaselineValue={getBaselineValue}
        // New concept sorting prop
        handleConceptSort={handleConceptSort}
        // New type selection props
        getSelectedForecastType={getSelectedForecastType}
        handleForecastTypeChange={handleForecastTypeChange}
        shouldShowToggle={shouldShowToggle}
        // New status prop
        getRowStatus={getRowStatus}
        // New filterpayload prop
        filterpayload={filterpayload}
      />
      <div className={classes.btnContainer}>
        <Button className={classes.cancelBtn} onClick={handleCancelButtonClick}>
          Cancel
        </Button>
      </div>

      <ConfirmationModal
        visibility={showCancelAlert}
        modalHeading="Confirmation"
        modalContent="You have not saved changes, are you sure you want to cancel ?"
        loading={false}
        confirmLabel="Confirm"
        handleCancel={() => setShowCancelAlert(false)}
        handleConfirm={() => {
          navigate(-1);
          setShowCancelAlert(false);
        }}
      />
    </div>
  );
};

export default ConstrainedForecastBulkEdit;
